export default __webpack_public_path__ + "static/media/pictogramHome64.b0514246.svg";